const assessmentPlaceApplications = [
    {
        "id":'1',
        "customer":"源天然股份有限公司",
        "no":"A21080203",
        "type":"initial",
        "createdOn":"2021-05-12T08:20:10.000Z",
        "customerBasicInfo":{
            "individual":false,
            "customerNo":"00020",
            "customerName":"源天然股份有限公司",
            "taxIdNo":"83793371",
            "personInCharge":"羅永昌",
            "registeredAddress":{
                "country":"TW",
                "zip":"958",
                "city":"taitung",
                "district":"池上鄉",
                "street":"振興村11鄰145號"
            },
            "tel":"089-360960",
            "standards":["tseyue","leezen"],
            "subContractorFilledCompletely":"Y",
            "qualityManagementDoc1":true,
            "qualityManagementDoc2":true,
            "qualityManagementDoc3":true,
            "qualityManagementDoc4":"prepared",
            "paymentAccount":{
                "bankCode":"822",
                "bankName":"中國信託",
                "branch":"台東分行",
                "accountName":"源天然股份有限公司",
                "accountNo":"0091234098"
            },
            "refundAccount":{
                "bankCode":"822",
                "bankName":"中國信託",
                "branch":"台東分行",
                "accountName":"源天然股份有限公司",
                "accountNo":"0091234110"
            },
            "commodityLabelStatements":[
                {
                    "filename":"A供應商商品標示.pdf",
                    "description":"A供應商商品標示聲明"
                },
                {
                    "filename":"B供應商商品標示.pdf",
                    "description":"B供應商商品標示聲明"
                },
                {
                    "filename":"C供應商商品標示.pdf",
                    "description":"C供應商商品標示聲明"
                },
                {
                    "filename":"D供應商商品標示.pdf",
                    "description":"D供應商商品標示聲明"
                },
                {
                    "filename":"E供應商商品標示.pdf",
                    "description":"E供應商商品標示聲明"
                },
                {
                    "filename":"F供應商商品標示.pdf",
                    "description":"F供應商商品標示聲明"
                }
            ]
        },
        "contactPersons":[
            {
                "id":"1",
                "name":"Judy Liu",
                "jobTitle":"行政專員",
                "phoneNumber":"02-7723-8001",
                "extension":"200",
                "mobilePhoneNumber":"0911234123",
                "fax":"02-7723-8002",
                "email":"judyliu@leandev.io",
                "mailingAddress":{
                    "country":"TW",
                    "zip":"958",
                    "city":"taitung",
                    "district":"池上鄉",
                    "street":"振興村11鄰145號"
                },
                "jobProperty":"primary",
            },
            {
                "id":"2",
                "name":"Howard Chen",
                "jobTitle":"行政專員",
                "phoneNumber":"02-8967-6666",
                "extension":"200",
                "mobilePhoneNumber":"0912345678",
                "fax":"02-1234-6666",
                "email":"howardChen@leandev.io",
                "mailingAddress":{
                    "country":"TW",
                    "zip":"234",
                    "city":"newTaipeiCity",
                    "district":"土城區",
                    "street":"廣興街7巷7號7樓"
                },
                "jobProperty":"familyMart",
            },
        ],
        "assessmentPlaces":[
            {
                "id":"1",
                "name":"台東廠",
                "personInCharge":"王小花",
                "masterAddress":"958台東縣池上鄉振興二號產業道路",
                "relationshipWithApplicant":"company",
                "productLabelingTel":"02-7723-8001",
                "factoryRegistration":"yes",
                "contactPerson":"王小花",
                "jobTitle":"行政專員",
                "email":"anniewang@gmail.com",
                "phoneNumber":"02-7723-8001",
                "extension":"201 ~ 203",
                "mobilePhone":"0911290098",
                "fax":"02-7723-8002",
                "passedManagementSystems":["iso2200","tqf","others"],
                "otherManagementSystem":"波蘭台北辦事處也在推特表示，「這是對需要幫助的朋友，我們所給予的堅定有力的支持」，也希望大家能健康平安，同時分享這批疫苗的照片，可以看見上面貼有「TAIWAN」字樣。",
                "managementSystemCertificateEffectiveDate":"2021-05-12T08:20:10.000Z",
                "passedManagementSystemCertificates":[
                    {"certificate":"ISO2200 證書", "effectiveDate":"2023-05-12T08:20:10.000Z"},
                    {"certificate":"TQF 證書", "effectiveDate":"2022-12-31T08:20:10.000Z"}
                ],
                "addresses":[
                    {
                        "country":"TW",
                        "zip":"11501",
                        "city":"taipei",
                        "district":"南港區",
                        "street":"三重路19-11號",
                        "mainAddress":true,
                        "fullAddress":"11501 台北市南港區三重路19-11號"
                    }
                ],
                "referenceDocument":{
                    "documentPoint1":"ready",
                    "documentPoint2":"ready",
                    "documentPoint3":"unused",
                    "documentPoint4":"ready",
                },
                "factoryFloorPlans":[
                    {
                        "id":"1",
                        "address":"11501 台北市南港區三重路19-11號",
                        "filename":"原料處理區及加工調理區.pdf",
                        "description":"原料處理區及加工調理區"
                    },
                    {
                        "id":"2",
                        "address":"11501 台北市南港區三重路19-11號",
                        "filename":"食品添加物室.jpeg",
                        "description":"食品添加物室"
                    }
                ],
                "productionLines":[
                    {
                        "id":"1",
                        "name":"果汁線",
                        "waterUse":"coolDown",
                        "processEquipments":[
                            {
                                "id":"1",
                                "equipment":"清洗設備",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"2",
                                "equipment":"榨汁機",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"3",
                                "equipment":"果汁緩衝桶",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"4",
                                "equipment":"半自動充填機",
                                "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                "frequency":"每生產前"
                            }
                        ],
                        "useLubricant":'Y',
                        "lubricantDescriptions":[
                            {
                                "id":"1",
                                "name":"烤盤專用油",
                                "element":"芥花油,大豆卵磷脂",
                                "usage":"用於烤盤"
                            },
                            {
                                "id":"2",
                                "name":"YY潤滑劑",
                                "element":"硫化鋅、石蠟、礦物油",
                                "usage":"輸送帶鏈條"
                            }
                        ]
                    },
                    {
                        "id":"2",
                        "name":"運動飲料線",
                        "waterUse":"others",
                        "waterUseDesc":"test111",
                        "processEquipments":[
                            {
                                "id":"1",
                                "equipment":"清洗設備111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"2",
                                "equipment":"榨汁機111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"3",
                                "equipment":"果汁緩衝桶111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"4",
                                "equipment":"半自動充填機111",
                                "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                "frequency":"每生產前"
                            }
                        ],
                        "useLubricant":'N'
                    }
                ]
            }
        ],
        "assessmentProducts":[
            {
                "id":"1",
                "name":"杏仁玄米餅",
                "combination":false,
                "tseyueStandard":true,
                "tseyueLevel":"doubleClean",
                "manufacturingProcess":"backEnd",
                "packagingMethods":["aluminumCan","glassBottle"],
                "processStatus":"frontEnd",
                "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "type":"material",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                     {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]
            },
            {
                "id":"2",
                "name":"Pasta義大利麵",
                "combination":true,
                "tseyueStandard":true,
                "leezenStandard":true,
                "tseyueLevel":"doubleClean",
                "leezenLevel":"organic",
                "manufacturingProcess":"backEnd",
                "processStatus":"backEnd",
                "packagingMethods":["plasticBag"],
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "semiFinishedProducts":[
                    {
                        "name":"半成品1",
                        "rawMaterials":[
                            {
                                "id":"1",
                                "name":"豆蓉粉(新版)",
                                "storageCondition":"roomTemperature",
                                "composition":"",
                                "domesticVendor":"穎昌食品有限公司(新和美)",
                                "importer":"",
                                "manufacturer":"穎昌食品有限公司(新和美)",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "addRatio":9,
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":1,
                                "relatedDocuments":[
                                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                                ]
                            },
                            {
                                "id":"2",
                                "name":"美國加州杏仁果",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信成股份有限公司",
                                "importer":"信成股份有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":2
                            },
                            {
                                "id":"3",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"爾邦得有限公司",
                                "importer":"爾邦得有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":3
                            },
                            {
                                "id":"4",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"RPAC,LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":4
                            },
                            {
                                "id":"5",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"VANN FAMLLY ORCHARDS",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":5
                            },
                            {
                                "id":"6",
                                "name":"甜扁桃仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"TWIN COMMODITIES,INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":6
                            },
                            {
                                "id":"7",
                                "name":"帶皮杏仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"昇祥股份有限公司",
                                "importer":"昇祥股份有限公司",
                                "manufacturer":"美國加州皮爾農場公司",
                                "originPlace":"美國加州",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":7
                            },
                            {
                                "id":"8",
                                "name":"有機生糙米粉(台灣)",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"青田農產有限公司",
                                "importer":"",
                                "manufacturer":"青田農產有限公司",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":8
                            },
                            {
                                "id":"9",
                                "name":"精製椰子油",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"禾發實業有限公司",
                                "importer":"禾發實業有限公司",
                                "manufacturer":"OLEO-FATS, INCORPORATED",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":9
                            },
                            {
                                "id":"10",
                                "name":"杏仁細粉",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"迦得貿易實業有限公司",
                                "importer":"迦得貿易實業有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":10
                            },
                            {
                                "id":"11",
                                "name":"杏仁粉(細)",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":11
                            },
                            {
                                "id":"12",
                                "name":"混合濃縮生育醇",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信意企業股份有限公司",
                                "importer":"信意企業股份有限公司",
                                "manufacturer":"CARGILL INCORPORATED",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                                "processingAid":"N",
                                "accessory":"N"
                            }
                        ]
                    },
                    {
                        "name":"半成品2",
                    }
                ],

            },
            {
                "id":"3",
                "name":"桂圓四物飲",
                "leezenStandard":true,
                "leezenLevel":"organic",
                "manufacturingProcess":"backEnd",
                "packagingMethods":["plasticBottle","plasticBottle"],
                "processStatus":"frontEnd",
                "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]
            },
            {
                "id":"4",
                "name":"Natural Benefits 食安生技-椰子汁",
                "tseyueStandard":true,
                "tseyueLevel":"allNature",
                "manufacturingProcess":"backEnd",
                "packagingMethods":["plasticBottle"],
                "processStatus":"frontEnd",
                "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]
            },
            {
                "id":"5",
                "name":"Natural Benefits 純在-蔬菜綜合果汁",
                "tseyueStandard":true,
                "tseyueLevel":"allNature",
                "manufacturingProcess":"backEnd",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]
            },
            {
                "id":"6",
                "name":"Natural Benefits 食安生技-芒果綜合果汁",
                "manufacturingProcess":"backEnd",
                "tseyueStandard":true,
                "tseyueLevel":"allNature",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]

            },
            {
                "id":"7",
                "name":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "manufacturingProcess":"backEnd",
                "tseyueStandard":true,
                "tseyueLevel":"allNature",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]
            }

        ]
    },
    {
        "id":'2',
        "customer":"源天然股份有限公司",
        "no":"A21080201",
        "type":"initial",
        "createdOn":"2021-05-12T08:20:10.000Z",
        "customerBasicInfo":{
            "individual":true,
            "customerNo":"00020",
            "customerName":"源天然股份有限公司",
            "taxIdNo":"83793371",
            "personInCharge":"羅永昌",
            "registeredAddress":{
                "country":"TW",
                "zip":"958",
                "city":"taitung",
                "district":"池上鄉",
                "street":"振興村11鄰145號"
            },
            "tel":"089-360960",
            "standards":["tseyue","leezen"],
            "subContractorFilledCompletely":"Y",
            "qualityManagementDoc1":true,
            "qualityManagementDoc2":true,
            "qualityManagementDoc3":true,
            "qualityManagementDoc4":"prepared",
            "paymentAccount":{
                "bankCode":"822",
                "bankName":"中國信託",
                "branch":"台東分行",
                "accountName":"源天然股份有限公司",
                "accountNo":"0091234098"
            },
            "refundAccount":{
                "bankCode":"822",
                "bankName":"中國信託",
                "branch":"台東分行",
                "accountName":"源天然股份有限公司",
                "accountNo":"0091234110"
            },
            "commodityLabelStatements":[
                {
                    "filename":"A供應商商品標示.pdf",
                    "description":"A供應商商品標示聲明"
                },
                {
                    "filename":"B供應商商品標示.pdf",
                    "description":"B供應商商品標示聲明"
                },
                {
                    "filename":"C供應商商品標示.pdf",
                    "description":"C供應商商品標示聲明"
                },
                {
                    "filename":"D供應商商品標示.pdf",
                    "description":"D供應商商品標示聲明"
                },
                {
                    "filename":"E供應商商品標示.pdf",
                    "description":"E供應商商品標示聲明"
                },
                {
                    "filename":"F供應商商品標示.pdf",
                    "description":"F供應商商品標示聲明"
                }
            ]
        },
        "contactPersons":[
            {
                "id":"1",
                "name":"Judy Liu",
                "jobTitle":"行政專員",
                "phoneNumber":"02-7723-8001",
                "extension":"200",
                "mobilePhoneNumber":"0911234123",
                "fax":"02-7723-8002",
                "email":"judyliu@leandev.io",
                "mailingAddress":{
                    "country":"TW",
                    "zip":"958",
                    "city":"taitung",
                    "district":"池上鄉",
                    "street":"振興村11鄰145號"
                },
                "jobProperty":"primary"
            },
            {
                "id":"2",
                "name":"Howard Chen",
                "jobTitle":"行政專員",
                "phoneNumber":"02-8967-6666",
                "extension":"200",
                "mobilePhoneNumber":"0912345678",
                "fax":"02-1234-6666",
                "email":"howardChen@leandev.io",
                "mailingAddress":{
                    "country":"TW",
                    "zip":"234",
                    "city":"newTaipeiCity",
                    "district":"土城區",
                    "street":"廣興街7巷7號7樓"
                },
                "jobProperty":"familyMart",
            },
        ],
        "assessmentPlaces":[
            {
                "id":"1",
                "name":"台東廠",
                "personInCharge":"王小花",
                "masterAddress":"958台東縣池上鄉振興二號產業道路",
                "relationshipWithApplicant":"company",
                "productLabelingTel":"02-7723-8001",
                "factoryRegistration":"yes",
                "contactPerson":"王小花",
                "jobTitle":"行政專員",
                "email":"anniewang@gmail.com",
                "phoneNumber":"02-7723-8001",
                "extension":"201 ~ 203",
                "mobilePhone":"0911290098",
                "fax":"02-7723-8002",
                "passedManagementSystems":["iso2200","tqf","others"],
                "otherManagementSystem":"波蘭台北辦事處也在推特表示，「這是對需要幫助的朋友，我們所給予的堅定有力的支持」，也希望大家能健康平安，同時分享這批疫苗的照片，可以看見上面貼有「TAIWAN」字樣。",
                "managementSystemCertificateEffectiveDate":"2021-05-12T08:20:10.000Z",
                "passedManagementSystemCertificates":[
                    {"certificate":"ISO2200 證書", "effectiveDate":"2023-05-12T08:20:10.000Z"},
                    {"certificate":"TQF 證書", "effectiveDate":"2022-12-31T08:20:10.000Z"}
                ],
                "addresses":[
                    {
                        "country":"TW",
                        "zip":"11501",
                        "city":"taipei",
                        "district":"南港區",
                        "street":"三重路19-11號",
                        "mainAddress":true,
                        "fullAddress":"11501 台北市南港區三重路19-11號"
                    }
                ],
                "referenceDocument":{
                    "documentPoint1":"ready",
                    "documentPoint2":"ready",
                    "documentPoint3":"unused",
                    "documentPoint4":"ready",
                },
                "factoryFloorPlans":[
                    {
                        "id":"1",
                        "address":"11501 台北市南港區三重路19-11號",
                        "filename":"原料處理區及加工調理區.pdf",
                        "description":"原料處理區及加工調理區"
                    },
                    {
                        "id":"2",
                        "address":"11501 台北市南港區三重路19-11號",
                        "filename":"食品添加物室.jpeg",
                        "description":"食品添加物室"
                    }
                ],
                "productionLines":[
                    {
                        "id":"1",
                        "name":"果汁線",
                        "waterUse":"coolDown",
                        "processEquipments":[
                            {
                                "id":"1",
                                "equipment":"清洗設備",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"2",
                                "equipment":"榨汁機",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"3",
                                "equipment":"果汁緩衝桶",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"4",
                                "equipment":"半自動充填機",
                                "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                "frequency":"每生產前"
                            }
                        ],
                        "useLubricant":'Y',
                        "lubricantDescriptions":[
                            {
                                "id":"1",
                                "name":"烤盤專用油",
                                "element":"芥花油,大豆卵磷脂",
                                "usage":"用於烤盤"
                            },
                            {
                                "id":"2",
                                "name":"YY潤滑劑",
                                "element":"硫化鋅、石蠟、礦物油",
                                "usage":"輸送帶鏈條"
                            }
                        ]
                    },
                    {
                        "id":"2",
                        "name":"運動飲料線",
                        "waterUse":"others",
                        "waterUseDesc":"test111",
                        "processEquipments":[
                            {
                                "id":"1",
                                "equipment":"清洗設備111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"2",
                                "equipment":"榨汁機111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"3",
                                "equipment":"果汁緩衝桶111",
                                "cleaningMethod":"CIP",
                                "frequency":"每次(品項)"
                            },
                            {
                                "id":"4",
                                "equipment":"半自動充填機111",
                                "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                "frequency":"每生產前"
                            }
                        ],
                        "useLubricant":'N'
                    }
                ]
            }
        ],
        "assessmentProducts":[
            {
                "id":"1",
                "name":"杏仁玄米餅",
                "combination":false,
                "tseyueStandard":true,
                "tseyueLevel":"doubleClean",
                "manufacturingProcess":"backEnd",
                "packagingMethods":["aluminumCan","glassBottle"],
                "processStatus":"frontEnd",
                "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "type":"material",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "type":"material",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]
            },
            {
                "id":"2",
                "name":"Pasta義大利麵",
                "combination":true,
                "tseyueStandard":true,
                "leezenStandard":true,
                "tseyueLevel":"doubleClean",
                "leezenLevel":"organic",
                "manufacturingProcess":"backEnd",
                "processStatus":"backEnd",
                "packagingMethods":["plasticBag"],
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "semiFinishedProducts":[
                    {
                        "name":"半成品1",
                        "rawMaterials":[
                            {
                                "id":"1",
                                "name":"豆蓉粉(新版)",
                                "storageCondition":"roomTemperature",
                                "composition":"",
                                "domesticVendor":"穎昌食品有限公司(新和美)",
                                "importer":"",
                                "manufacturer":"穎昌食品有限公司(新和美)",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "addRatio":9,
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":1,
                                "relatedDocuments":[
                                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                                ]
                            },
                            {
                                "id":"2",
                                "name":"美國加州杏仁果",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信成股份有限公司",
                                "importer":"信成股份有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":2
                            },
                            {
                                "id":"3",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"爾邦得有限公司",
                                "importer":"爾邦得有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":3
                            },
                            {
                                "id":"4",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"RPAC,LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":4
                            },
                            {
                                "id":"5",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"VANN FAMLLY ORCHARDS",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":5
                            },
                            {
                                "id":"6",
                                "name":"甜扁桃仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"TWIN COMMODITIES,INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":6
                            },
                            {
                                "id":"7",
                                "name":"帶皮杏仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"昇祥股份有限公司",
                                "importer":"昇祥股份有限公司",
                                "manufacturer":"美國加州皮爾農場公司",
                                "originPlace":"美國加州",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":7
                            },
                            {
                                "id":"8",
                                "name":"有機生糙米粉(台灣)",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"青田農產有限公司",
                                "importer":"",
                                "manufacturer":"青田農產有限公司",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":8
                            },
                            {
                                "id":"9",
                                "name":"精製椰子油",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"禾發實業有限公司",
                                "importer":"禾發實業有限公司",
                                "manufacturer":"OLEO-FATS, INCORPORATED",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":9
                            },
                            {
                                "id":"10",
                                "name":"杏仁細粉",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"迦得貿易實業有限公司",
                                "importer":"迦得貿易實業有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":10
                            },
                            {
                                "id":"11",
                                "name":"杏仁粉(細)",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":11
                            },
                            {
                                "id":"12",
                                "name":"混合濃縮生育醇",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信意企業股份有限公司",
                                "importer":"信意企業股份有限公司",
                                "manufacturer":"CARGILL INCORPORATED",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                                "processingAid":"N",
                                "accessory":"N"
                            }
                        ]
                    },
                    {
                        "name":"半成品2",
                    }
                ],

            },
            {
                "id":"3",
                "name":"桂圓四物飲",
                "leezenStandard":true,
                "leezenLevel":"organic",
                "manufacturingProcess":"backEnd",
                "packagingMethods":["plasticBottle","plasticBottle"],
                "processStatus":"frontEnd",
                "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]
            },
            {
                "id":"4",
                "name":"Natural Benefits 食安生技-椰子汁",
                "tseyueStandard":true,
                "tseyueLevel":"allNature",
                "manufacturingProcess":"backEnd",
                "packagingMethods":["plasticBottle"],
                "processStatus":"frontEnd",
                "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]
            },
            {
                "id":"5",
                "name":"Natural Benefits 純在-蔬菜綜合果汁",
                "tseyueStandard":true,
                "tseyueLevel":"allNature",
                "manufacturingProcess":"backEnd",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]
            },
            {
                "id":"6",
                "name":"Natural Benefits 食安生技-芒果綜合果汁",
                "manufacturingProcess":"backEnd",
                "tseyueStandard":true,
                "tseyueLevel":"allNature",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]

            },
            {
                "id":"7",
                "name":"Natural Benefits 純在葡萄柚蘋果綠茶",
                "manufacturingProcess":"backEnd",
                "tseyueStandard":true,
                "tseyueLevel":"allNature",
                "storageCondition":"freezing",
                "shelfLife":1,
                "shelfLifeUnit":"year",
                "onMarketForSale":"yes",
                "saleArea":"onlyTaiwan",
                "lowAcidFood":"N",
                "applyStandards":[
                    {
                        "id":"11",
                        "standard":"tseyueStandard",
                        "level":"doubleClean"
                    }
                ],
                "placesAndLines":[
                    {
                        "place":"1",
                        "lines":["1","2"]
                    }
                ],
                "innerPackages":[
                    {
                        "packaging":"glassBottle",
                        "specs":[
                            {"spec":"360ml/瓶", "channels":["leezen","family"]},
                            {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "bottleInnerMaterial":"PE發泡塑膠",
                        "vacuumOrDesiccant":"Y",
                        "recycledAndReused":"N",
                        "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                    },
                    {
                        "packaging":"plasticBag",
                        "specs":[
                            {"spec":"1公斤/包", "channels":["leezen","family"]},
                            {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                        ],
                        "material":"聚乙烯（PE)",
                        "vacuumOrDesiccant":"N",
                        "recycledAndReused":"N"
                    }
                ],
                "relatedAttachments":[
                    {"type":"productionFlowChart"},
                    {"type":"productionSpecSheet"},
                    {"type":"productionSpecSheet"},
                    {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                    {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                    {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                    {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                    {"type":"alcoholTestReport"}
                ],
                "rawMaterials":[
                    {
                        "id":"1",
                        "name":"豆蓉粉(新版)",
                        "storageCondition":"roomTemperature",
                        "composition":"",
                        "domesticVendor":"穎昌食品有限公司(新和美)",
                        "importer":"",
                        "manufacturer":"穎昌食品有限公司(新和美)",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "addRatio":9,
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":1,
                        "relatedDocuments":[
                            {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                            {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                        ]
                    },
                    {
                        "id":"2",
                        "name":"美國加州杏仁果",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信成股份有限公司",
                        "importer":"信成股份有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":2
                    },
                    {
                        "id":"3",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"爾邦得有限公司",
                        "importer":"爾邦得有限公司",
                        "manufacturer":"TERRA NOVA TRADING INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":3
                    },
                    {
                        "id":"4",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"RPAC,LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":4
                    },
                    {
                        "id":"5",
                        "name":"美國加州杏仁果",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"信和股份有限公司",
                        "importer":"信和股份有限公司",
                        "manufacturer":"VANN FAMLLY ORCHARDS",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":5
                    },
                    {
                        "id":"6",
                        "name":"甜扁桃仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"TWIN COMMODITIES,INC.",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":6
                    },
                    {
                        "id":"7",
                        "name":"帶皮杏仁粒",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"昇祥股份有限公司",
                        "importer":"昇祥股份有限公司",
                        "manufacturer":"美國加州皮爾農場公司",
                        "originPlace":"美國加州",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":7
                    },
                    {
                        "id":"8",
                        "name":"有機生糙米粉(台灣)",
                        "storageCondition":"refrigeration",
                        "domesticVendor":"青田農產有限公司",
                        "importer":"",
                        "manufacturer":"青田農產有限公司",
                        "originPlace":"台灣",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":8
                    },
                    {
                        "id":"9",
                        "name":"精製椰子油",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"禾發實業有限公司",
                        "importer":"禾發實業有限公司",
                        "manufacturer":"OLEO-FATS, INCORPORATED",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":9
                    },
                    {
                        "id":"10",
                        "name":"杏仁細粉",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"迦得貿易實業有限公司",
                        "importer":"迦得貿易實業有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"菲律賓",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":10
                    },
                    {
                        "id":"11",
                        "name":"杏仁粉(細)",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"成久旺股份有限公司",
                        "importer":"成久旺股份有限公司",
                        "manufacturer":"Treehouse California Almonds LLC",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"",
                        "processingAid":"N",
                        "accessory":"N",
                        "ingredientOrder":11
                    },
                    {
                        "id":"12",
                        "name":"混合濃縮生育醇",
                        "storageCondition":"roomTemperature",
                        "domesticVendor":"信意企業股份有限公司",
                        "importer":"信意企業股份有限公司",
                        "manufacturer":"CARGILL INCORPORATED",
                        "originPlace":"美國",
                        "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                        "processingAid":"N",
                        "accessory":"N"
                    }
                ]
            }

        ]
    }
]

export default assessmentPlaceApplications;